import PropTypes from "prop-types"
import React, {PureComponent, ComponentClass, RefObject} from "react"

export interface ValidatedScreenProps {
  forwardedRef?: any
}

export default function validatedScreen<Props>(
  Screen: React.ComponentType<Props & ValidatedScreenProps>,
  displayName: string,
  {withRef = false} = {}
): ComponentClass<Pick<Props, Exclude<keyof Props, keyof ValidatedScreenProps>>> & {
  WrappedComponent: React.ComponentType<Props & ValidatedScreenProps>
} {
  type PrivateProps = {
    forwardedRef?: RefObject<typeof Screen>
  }

  type State = {
    errors: any
  }

  class ValidatedScreen extends PureComponent<PrivateProps & Props, State> {
    static navigationOptions = Screen.navigationOptions

    static childContextTypes = {
      currentScreen: PropTypes.string.isRequired
    }

    getChildContext() {
      return {
        currentScreen: displayName
      }
    }

    render() {
      const {forwardedRef} = this.props
      return <Screen {...this.props} ref={forwardedRef} />
    }
  }

  if (withRef) {
    return React.forwardRef<typeof Screen, OriginalProps>((props, ref) => {
      return <ValidatedScreen {...props} forwardedRef={ref} />
    })
  }

  return ValidatedScreen
}
